import React, { useEffect, useRef } from "react";
import VanillaTilt from "vanilla-tilt";
import { useAudio } from "./AudioContext";

export default function IconCard({ icon, link }) {
  const tiltRef = useRef(null);
  const { playAudio, playPop, pausePop } = useAudio();

  const handleClick = () => {
    playAudio();
  };

  const handleMouseEnter = () => {
    playPop(0.3);
  };

  const handleMouseLeave = () => {
    pausePop();
  };

  useEffect(() => {
    if (tiltRef.current) {
      VanillaTilt.init(tiltRef.current, {
        scale: 1.1,
        max: 25,
        speed: 400,
        glare: true,
        "max-glare": 1,
      });
    }
  }, []);

  return (
    <div ref={tiltRef} className="iconcard">
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <i className={icon}></i>
      </a>
    </div>
  );
}
